import React from 'react'
import SEO from 'src/components/common/SEO'
import { videos } from 'src/constants'
import { Helmet } from 'react-helmet'
import {
  Layout,
  ChannelSection,
  DealSection,
  FAQSection,
  NetworkSection,
  PlatformSection,
  RSNGeolocationBanner,
  HeroVideoPlayer,
} from 'src/components/common'

const OneboxTemplateDefault = ({
  location,
  lang = 'en',
  market = 'us',
  ctaHrefOverride,
  // Offer Code
  offerCode,
  offerBanner,
  // Metadata
  pageTitle,
  pageDescription,
  // Hero Section
  logo,
  logoHeight,
  title,
  subtitle,
  ctaText,
  video,
  videoUrlBase,
  background,
  // Network Section
  networkHeadline,
  networkSet,
  customNetworks,
  // Disable Free Trial
  disableFreeTrial = true,
  // Others
  team,
  showRSN,
  // Personalization Params
  sportId,
  leagueId,
  teamId,
  // Additional FAQs
  additionalFAQs,
  faqListOverride,
}) => {
  // Disable Free Trial Modifications
  const modifiedCtaText = ctaText

  const modifiedNetworkSubtitle =
    disableFreeTrial && (lang === 'es' ? 'Cancela cuando quieras.' : 'Cancel online anytime.')

  let metaDescription =
    pageDescription ||
    // TEMPORARY NBC DISPUTE
    // '200+ live channels. Free Cloud DVR. Watch on your phone, Roku, Apple TV, Amazon Fire TV, computer & more. FOX, NBC, CBS, NFL Network, SHOWTIME, beIN SPORTS & more.'
    '200+ live channels. Free Cloud DVR. Watch on your phone, Roku, Apple TV, Amazon Fire TV, computer & more. FOX, CBS, NFL Network, SHOWTIME, beIN SPORTS & more.'

  return (
    <Layout
      lang={lang}
      market={market}
      offerCode={offerCode}
      offerBanner={offerBanner}
      sportId={sportId}
      leagueId={leagueId}
      teamId={teamId}
    >
      <Helmet>
        <link rel="preconnect" crossOrigin="anonymous" href="https://marketing-partners.fubo.tv" />
        <link
          rel="dns-prefetch"
          crossOrigin="anonymous"
          href="https://marketing-partners.fubo.tv"
        />
      </Helmet>
      <SEO lang={lang} market={market} title={pageTitle || title} description={metaDescription} />
      <HeroVideoPlayer
        location={location}
        video={video || videos.generic_soccer.videoUrl}
        title={title}
        subTitle={subtitle}
        videoUrlBase={videoUrlBase}
        background={background}
        ctaText={modifiedCtaText}
        ctaHrefOverride={ctaHrefOverride}
        logo={logo}
        logoHeight={logoHeight}
        market={market}
        lang={lang}
        disableFreeTrial={disableFreeTrial}
      />
      {showRSN && (
        <RSNGeolocationBanner
          ctaText={modifiedCtaText}
          ctaHrefOverride={ctaHrefOverride}
          lang={lang}
          market={market}
          disableFreeTrial={disableFreeTrial}
        />
      )}
      <NetworkSection
        lang={lang}
        market={market}
        networkHeadline={networkHeadline}
        subtitle={modifiedNetworkSubtitle}
        networkSet={networkSet}
        customNetworks={customNetworks}
        ctaText={modifiedCtaText}
        disableFreeTrial={disableFreeTrial}
      />
      <ChannelSection lang={lang} market={market} />
      <DealSection lang={lang} market={market} />
      <PlatformSection
        lang={lang}
        market={market}
        ctaText={modifiedCtaText}
        disableFreeTrial={disableFreeTrial}
      />
      <FAQSection
        lang={lang}
        market={market}
        team={team}
        additionalFAQs={additionalFAQs}
        faqListOverride={faqListOverride}
      />
    </Layout>
  )
}

export default OneboxTemplateDefault
